import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { changeOnlyUnread, changeReadState, hideNotification, setNotifications } from './notifications.actions';
import { Notification } from './notifications.model';


export interface State {
    notifications: Notification[];
    loaded: boolean;
    onlyUnread: boolean;
}

export const initialState: State = {
    notifications: [],
    loaded: false,
    onlyUnread: true,
};

export const notificationsReducer = createReducer(
    initialState,
    on(setNotifications, (state, { notifications }) => ({
        ...state,
        notifications: notifications,
        loaded: true,
    })),
    on(changeReadState, (state, { notifications }) => ({
        ...state,
        notifications: state.notifications.map(n => {
            let result = n;
            notifications.forEach(notification => {
                if (notification.notificationId === n.notificationId) {
                    result = { ...n, read: notification.read };
                }
            });
            return result;
        }),
    })),
    on(hideNotification, (state, { notificationId }) => ({
        ...state,
        notifications: state.notifications.map(n => n.notificationId === notificationId ? { ...n, hidden: true } : n),
    })),
    on(changeOnlyUnread, (state, { unread }) => ({
        ...state,
        onlyUnread: unread,
    })),
);

const selector = createFeatureSelector<State>('notifications');

const getActives = (s: State) => s.notifications.filter(n => !n.hidden);
const sum = (numbers: number[]) => numbers.reduce((a, b) => a + b, 0);

const onlyUnread = (s: State) => s.notifications.filter(n => !s.onlyUnread || s.onlyUnread && !n.read);

export const getNotifications = createSelector(selector, onlyUnread);
export const getUnreadCount = createSelector(selector, state => sum(getActives(state).map(n => n.read ? 0 : 1)));
export const getOnlyUnread = createSelector(selector, state => state.onlyUnread);
export const getNotificationsToDisplay = createSelector(selector, getActives);
export const getLoadedState = createSelector(selector, state => state.loaded);
